// extracted by mini-css-extract-plugin
module.exports = {"user":"User_user__3oH54","ont":"User_ont__2ZKHU","avatar":"User_avatar__XLnaT","arrow":"User_arrow__2Uo9Y"};